import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "./es.json";
import ca from "./ca.json";
import en from "./en.json";

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        es: { translation: es },
        ca: { translation: ca },
        en: { translation: en },
      },
      fallbackLng: "es",
      supportedLngs: ["es", "ca", "en"],
      interpolation: { escapeValue: false },
      detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
        lookupLocalStorage: "watts_lang",
      },
    });
}

export const LANGUAGES = [
  { code: "es", label: "Español", display: "Español" },
  { code: "ca", label: "Català", display: "Català" },
  { code: "en", label: "English", display: "English" },
] as const;

export default i18n;
